<template>
  <div id="pdfContainer" ref="pdfContainer" v-loading="loadingActive" element-loading-text="拼命加载中">
    <iframe :src="urlSrc"></iframe>
  </div>
</template>

<script>
import { scanUrl } from "@/CommonDP/utils";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default {
  data() {
    return {
      loadingActive: true,
      urlSrc: ""
    };
  },

  async mounted() {
    const { f, n } = this.$route.query;
    document.title = n;
    const url = scanUrl(f, "");
    this.urlSrc = `./pdf/web/viewer.html?file=${encodeURIComponent(url)}`;
    this.initEvent();

    window.callBackError = () => {
      Toast("文档加载失败");
    };

    window.callBackSuccess = () => {
      this.loadingActive = false;
    };
  },

  methods: {
    initEvent() {
      console.log("初始化监听事件");
      document.addEventListener("touchstart", this.touch2mouse, true);
      document.addEventListener("touchmove", this.touch2mouse, true);
      document.addEventListener("touchend", this.touch2mouse, true);
    },

    touch2mouse(event) {
      var touches = event.changedTouches;
      var first = touches[0];
      var type = "";
      switch (event.type) {
        case "touchstart":
          type = "mousedown";
          break;
        case "touchmove":
          type = "mousemove";
          break;
        case "touchend":
          type = "mouseup";
          break;
        default:
          return;
      }

      var simulatedEvent = document.createEvent("MouseEvent");
      simulatedEvent.initMouseEvent(
        type,
        true,
        true,
        window,
        1,
        first.screenX,
        first.screenY,
        first.clientX,
        first.clientY,
        false,
        false,
        false,
        false,
        null
      );
      first.target.dispatchEvent(simulatedEvent);
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#pdfContainer {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;

  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
